import { render, staticRenderFns } from "./TypographyCategorySelect.vue?vue&type=template&id=94d58d02&scoped=true&"
import script from "./TypographyCategorySelect.vue?vue&type=script&lang=js&"
export * from "./TypographyCategorySelect.vue?vue&type=script&lang=js&"
import style0 from "./TypographyCategorySelect.vue?vue&type=style&index=0&id=94d58d02&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94d58d02",
  null
  
)

export default component.exports